import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BlankSlate from 'modules/reviews/components/Analytics/BlankSlate'
import Filters from 'modules/reviews/components/Analytics/ScoreResults/Filters'
import ScoreForm from 'modules/reviews/components/Analytics/ScoreResults/ScoreForm'
import { title } from 'modules/reviews/components/Analytics/utilities'
import type AnalyticResults from 'modules/reviews/store/collections/analyticResults'
import { GroupedBy } from 'modules/surveys/store/models/AnalyticResult'
import { AggregateOperations } from 'modules/surveys/store/models/AnalyticResult'

import BarChart from './BarChart'

interface Props {
  formName: string
  analyticResults: typeof AnalyticResults
}

const ScoreResults = ({ formName, analyticResults }: Props) => {
  const scoreForm = React.useRef(
    new ScoreForm({
      grouped_by: GroupedBy.Questions,
      aggregate_operation: AggregateOperations.Avg,
    })
  ).current

  if (analyticResults.length === 0) {
    return <BlankSlate />
  }

  if (analyticResults.numeric.length === 0) {
    return <BlankSlate numericalResults />
  }

  return (
    <Box gap="s32">
      <Filters scoreForm={scoreForm} />
      {analyticResults.numeric.map((analyticResult) => {
        return (
          <BarChart
            key={analyticResult.attributes.id}
            analyticResult={analyticResult}
            scoreForm={scoreForm}
            title={title(formName, analyticResult.typeOfReviewer)}
          />
        )
      })}
    </Box>
  )
}

export default observer(ScoreResults)
